"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighLowSetting = void 0;
var HighLowSetting;
(function (HighLowSetting) {
    HighLowSetting["HIGH"] = "High";
    HighLowSetting["LOW"] = "Low";
    HighLowSetting["HI_LO"] = "Hi-Lo";
})(HighLowSetting || (exports.HighLowSetting = HighLowSetting = {}));
//# sourceMappingURL=HighLowSetting.js.map